var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"seeReport","title":"BreakDown Report","ok-only":true,"ok-title":"Close","lazy":true}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"width":"100","frameborder":"0","size":"lg"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d878d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MDemoBreakdownReport.vue
// module id = null
// module chunks = 